import 'lazysizes';
console.debug('LazySizes loaded and ready');